<nav class="w-full flex flex-col justify-center max-lg:gap-4 2xl:px-16 lg:px-10 md:px-10 px-4 lg:py-4 py-8 md:bg-white bg-[#F6F6F6]">
  <div class="w-full flex justify-between">
    <div class="flex justify-center items-center gap-7">

      <div class="flex justify-center items-start gap-4">
          <div class="bg-blue-300 rounded-full overflow-hidden">
              <img [src]="(isVendor && vendorProfile.vendor()?.logo) || 'shared/navbar/avatar-female.png'" alt="" class="2xl:w-10 2xl:h-10 w-9 h-9 object-cover">
          </div>
          <div class="text-start">
              <p class="text-[#1F1F1F] font-medium 2xl:text-sm text-xs capitalize">
                <ng-container *ngIf="languageService.currentLang() === 'ar'; else englishName">
                  {{ JwtPayload?.first_name_ar }} {{ JwtPayload?.last_name_ar }}
                </ng-container>
                <ng-template #englishName>
                  {{ JwtPayload?.first_name }} {{ JwtPayload?.last_name }}
                </ng-template>
              </p>
              <p class="text-[#8E8E8E] 2xl:text-[0.77rem] text-[0.7rem]">
                <ng-container *ngIf="isVendor && vendorProfile.vendor() as vendor; else userRole">
                  {{ languageService.currentLang() === 'ar' ? vendor.shop_name_ar : vendor.shop_name_en }}
                </ng-container>
                <ng-template #userRole>{{ getUserRole() | translate }}</ng-template>
              </p>
          </div>
      </div>

    </div>

    <div class="flex justify-center items-center 2xl:gap-5 gap-3.5">
        <div class="border-[#D1D1DB] border 2xl:w-9 2xl:h-9 w-8 h-8 rounded-full flex justify-center items-center">
            <i class="bi bi-bell 2xl:text-sm text-xs"></i>
        </div>
        <div class="relative inline-block">
          <div (click)="toggleLanguageDropdown()"
            class="cursor-pointer text-[#1F1F1F] border-[#D1D1DB] border py-2 px-3 rounded-full 2xl:text-xs text-[0.6rem] font-light flex items-center gap-2 select-none"
          >
          {{ 'common.languages.' + languageService.currentLang() | translate }}
          <i class="bi bi-chevron-down 2xl:text-[0.6rem] text-[0.5rem] transition duration-300" [class.rotate-180]="isLanguageOpen"></i>
          </div>

          <div *ngIf="isLanguageOpen"
            class="w-24 absolute mt-2 -start-6 end-0 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden z-50"
          >
            <button (click)="changeLanguage('ar')" class="w-full flex justify-end items-center gap-2 px-3 py-2 text-end hover:bg-gray-100 2xl:text-xs text-[10px] font-light cursor-pointer">
              {{ 'common.languages.ar' | translate }}
              <img src="shared/navbar/ar_flag.png" alt="" class="w-3 h-3">
            </button>
            <button (click)="changeLanguage('en')" class="w-full flex justify-end items-center gap-2 px-3 py-2 text-end hover:bg-gray-100 2xl:text-xs text-[10px] font-light cursor-pointer">
              {{ 'common.languages.en' | translate }}
              <img src="shared/navbar/en_flag.png" alt="" class="w-3 h-3">
            </button>
          </div>
        </div>
        <button class="lg:hidden cursor-pointer" (click)="menuClick.emit()">
          <i class="bi bi-list text-2xl"></i>
        </button>
    </div>
  </div>
</nav>
